import { Route, Switch } from "wouter";
import Home from "./pages/Home";
import Admin from "./pages/admin/Admin";
import AdminLogin from "./pages/admin/AdminLogin";
function App() {
  return <Switch>
      <Route path="/" component={Home} />

      <Route path="/admin/login" component={AdminLogin} />
      <Route path="/admin/content" component={Admin} />
      <Route path="/admin/photos" component={Admin} />
      <Route path="/admin/videos" component={Admin} />
      <Route path="/admin/music" component={Admin} />
      <Route path="/admin/schedule" component={Admin} />
      <Route path="/admin/settings" component={Admin} />
      <Route path="/admin" component={Admin} />

      <Route>
        {() => <main className="grid min-h-[100svh] place-items-center px-6">
            <div className="glass max-w-sm rounded-2xl p-8 text-center">
              <p className="eyebrow">Not here</p>
              <h1 className="display-md mt-2 gold-text">This page doesn&apos;t exist</h1>
              <a href="/" className="btn-gold mt-6">
                Go to the site
              </a>
            </div>
          </main>}
      </Route>
    </Switch>;
}
export {
  App as default
};
